import { ContractBreadcrumbs } from "./contract-breadcrumb";

export const ContractHeader = () => {
  return (
    <div className="sticky z-40 top-12 md:top-16 group-has-[[data-collapsible=icon]]/sidebar-wrapper:top-12 md:group-has-[[data-collapsible=icon]]/sidebar-wrapper:top-12 transition-[top] ease-linear w-full bg-background border-b shrink-0 h-12 flex items-center px-4 justify-start gap-4">
      <ContractBreadcrumbs />
    </div>
  );
};
